import { getFlag } from '@sportson/core-web/utils/getFlag';
import getProductStockStatus, { getPackageStockStatus } from '@sportson/core-web/utils/getProductStockStatus';
import { PRODUCT_BACKORDER, PRODUCT_PREORDER } from 'config/constants';

/**
 * Get product availability status
 * @param {Object} product - product object
 * @param {String} locale - locale
 * @param {'onHand'|'onHandStore'|'onHandSupplier'} specificStockProperty - specific stock property
 */
export const getProductAvailability = (product, locale, specificStockProperty = false) => {
    const {
        format: { flags },
        onHand,
        onHandStore,
        included_products: includedProducts,
    } = product;

    let selectedOnHand = onHand;

    if (specificStockProperty) {
        selectedOnHand = product[specificStockProperty];
    }

    let stockStatus;

    if (includedProducts?.length) {
        // package product
        [stockStatus] = getPackageStockStatus(includedProducts, locale);
    } else {
        // non-package
        stockStatus = getProductStockStatus(selectedOnHand, locale);
    }

    if (onHand?.value > 0 || onHandStore?.value > 0 || stockStatus.stock > 0) {
        return { inStock: true };
    }
    if (stockStatus.nextDelivery) {
        if (getFlag(PRODUCT_PREORDER, flags)) {
            return { preOrder: true, nextDelivery: stockStatus.nextDelivery };
        }
        if (getFlag(PRODUCT_BACKORDER, flags)) {
            return { backOrder: true, nextDelivery: stockStatus.nextDelivery };
        }
    }

    return { inStock: false };
};

export const getAvailabilitySchemaUrl = (productAvailability) =>
    productAvailability.inStock
        ? 'http://schema.org/InStock'
        : productAvailability.preOrder
          ? 'https://schema.org/PreOrder'
          : productAvailability.backOrder
            ? 'https://schema.org/BackOrder'
            : 'http://schema.org/OutOfStock';
